import React, { useState, useEffect } from "react";
import { Container, Col, Row, Alert } from "reactstrap";
import * as Loading from "@repoflow/components/loading";
import { useQuery } from "@apollo/client";
import * as CaptchaLib from "@repoflow/browser/captcha";
import { useCaptcha } from "@repoflow/components/captcha";

export const QueryContent = (props) => {
  const { publicKey, ready } = useCaptcha();

  if (!ready) {
    return (
      <div className="mt-4">
        <Loading.Content />
      </div>
    );
  }

  return <CaptchaContent {...props} publicKey={publicKey} />
};


const CaptchaContent = (props) => {
  const { publicKey } = props;
  const [token, setToken] = useState(null)

  useEffect(() => {
    CaptchaLib.request(publicKey, (token) => {
      setToken(token)
    })
  }, [])

  if (!token) {
    return (
      <div className="mt-4">
        <Loading.Content />
      </div>
    );
  }

  return (
    <DataContent {...props} token={token} />
  );

}


const DataContent = ({
  children: Children,
  query,
  variables,
  attributes,
  token
}) => {
  const { loading, error, data, refetch } = useQuery(query, { variables: { ...variables, token } });

  if (loading) {
    return (
      <div className="mt-4">
        <Loading.Content />
      </div>
    );
  }
  // These are the signed-out pages: sign in, sign up, validate. Dumping the
  // raw GraphQL message replaced the whole form with a string and left the
  // visitor no way forward, so the detail goes to the console instead.
  if (error) {
    console.error("content-query-anonymous:", error);
    return (
      <Container className="mt-4">
        <Row>
          <Col>
            <Alert color="danger">
              This link is not valid or has expired. Please check the address
              you were given, or contact support if the problem persists.
            </Alert>
          </Col>
        </Row>
      </Container>
    );
  }

  const anonymous = data.viewer.anonymous;

  return (
    <Children
      anonymous={anonymous}
      variables={variables}
      query={query}
      refetch={refetch}
      attributes={attributes}
    />
  );

}
